import { createSlice } from "@reduxjs/toolkit";
import { actions } from "react-table";

const params = {
    "page": 1,
    "pageSize": 100,
    "sortOrder": "string",
    "sortColumn": "string",
    "startDate": null,
    "endDate": null,
    "message": "",
    "searchText":"",
    isArchived: false
}
export const initialState = {
    data: [],
    params: params,
    masterData: {
        readList: [
            { name: "New", value: 0 },
            { name: "Resolved", value: 1 }
        ]
    },
    totalCount: 0,
    loadingFlag: 0,
    gpsData: [],
    gpsCount: 0,
    error: ''
}

export const inboxSlice = createSlice({
    name: "gps",
    initialState,
    reducers: {
        setParams: (state, action) => {
            state.params = action.payload;
        },
        setInboxMessages: (state, action) => {
            state.data = action.payload
        },
        setTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        setLodingFlagIncrement: (state) => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLodingFlagDecrement: (state) => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        },
        resetInboxMsgParams: state => {
            state.params = initialState.params;
        },
        updateInboxMsgParams: (state, { payload: { name, value } }) => {
            state.params[name] = value;
        },
        setParams: (state, action) => {
            state.params = action.payload;
        },
        setGpsData: (state, { payload }) => {
            state.gpsData = payload.data;
            state.gpsCount = payload.count;
        },
        setError: (state, { payload }) => {
            state.error = payload
        }
    }
});

export const { setParams, setInboxMessages, setTotalCount, setLodingFlagDecrement, setLodingFlagIncrement, resetInboxMsgParams, updateInboxMsgParams, setGpsData, setError } = inboxSlice.actions;
export default inboxSlice.reducer